import styled from 'styled-components';
import { layout, colors } from '@prisjakt/ui-base';
import CloseIcon from 'mdi-react/CloseCircleOutlineIcon';

export const SearchBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${layout.searchBar.height.desktop.rem};
  overflow: hidden;
  position: relative;
  border-radius: ${layout.borderRadius};
  box-shadow: 0 2px 4px rgba(#000, 0.2);
`;

export const InputWrapper = styled.div`
  overflow: hidden;
  background: ${colors.white};
  border-radius: ${layout.borderRadius};
  padding: 0.2rem;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 1;
`;

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  padding: 0.5rem 10px;

  &:focus {
    outline: none;
  }
`;

type ClearIconProps = {
  show?: boolean;
};

export const ClearIcon = styled.button<ClearIconProps>`
  padding-right: 0.7rem;
  display: ${props => (props.show ? 'block' : 'none')};
`;

export const Close = styled(CloseIcon)`
  color: ${props => props.theme.icons.tertiary};
`;
